
import { Component, OnInit } from "@angular/core";
import { RavenApiService } from "../raven-api.service"

import { ActivatedRoute } from "@angular/router";

import { RavenApiSettings } from "../models/raven-api-settings";
import { ITestApiResult } from "../models/test-api-result";

@Component({
    selector: "raven-api",
    templateUrl: "raven-api-settings.component.html",
    styleUrls: ["raven-api-settings.component.scss"]

})
export class RavenApiSettingsComponent implements OnInit {
    settings: RavenApiSettings;
    testApiStatus: TestApiStatus;
    testApiStatusEnum = TestApiStatus;
    disableTest: boolean = false;
    disableSave: boolean = false;
    username: string;
    password: string;
    showRavenUpdateMessage: boolean = false;

    constructor(private route: ActivatedRoute,
                private ravenApiService: RavenApiService) { }

    ngOnInit(): void {
        this.ravenApiService.getSettings().then(x => {
            this.settings = x || new RavenApiSettings();
            this.username = this.settings.username;
            this.password = this.settings.password;
        });
        this.testApiStatus = TestApiStatus.None;
    }

    changedInputUsername(value: any) {
        if(value !== this.settings.username){
            this.disableTest = true;
            this.testApiStatus = TestApiStatus.None;
        }else{
            this.disableTest = false;
        }
    }

    changedInputPassword(value: any) {
        if(value !== this.settings.password){
            this.disableTest = true;
            this.testApiStatus = TestApiStatus.None;
        }else{
            this.disableTest = false;
        }
    }

    testApi() {
        this.disableTest = true;
        this.disableSave = true;
        this.testApiStatus = TestApiStatus.None;
        this.ravenApiService.test(this.settings).then(x => {
            if (x) {
                this.testApiStatus = TestApiStatus.Passed;
                this.showRavenUpdateMessage = true;
                this.ravenApiService.updateFieldsFromRaven(this.settings).then(() => {
                    this.showRavenUpdateMessage = false;
                    this.disableTest = false;
                    this.disableSave = false;
                });
            } else {
                this.testApiStatus = TestApiStatus.Failed;
                this.disableTest = false;
                this.disableSave = false;
            }

        }).catch(ex => {
            this.testApiStatus = TestApiStatus.Failed;
            this.disableTest = false;
            this.disableSave = false;
        });
    }

    save() {
        this.settings.username = this.username;
        this.settings.password = this.password;
        this.testApiStatus = TestApiStatus.None;
        this.disableSave = true;
        this.ravenApiService.saveSettings(this.settings).then(() => {
            this.disableTest = false;
            this.disableSave = false;
            this.ravenApiService.getSettings().then(x => {
                this.settings = x || new RavenApiSettings();
                this.username = this.settings.username;
                this.password = this.settings.password;
            });
        }).catch(ex => {
            this.disableTest = false;
            this.disableSave = false;
        });;
        
    }
}

export enum TestApiStatus {
    None,
    Passed,
    Failed
}